export const ARTICLES_PER_PAGE = 9;

export const GLOSSARY_TERMS_PER_PAGE = 10;
